<mat-sidenav-container>
    <mat-sidenav></mat-sidenav>
    <mat-sidenav-content>

        <lomas-public-toolbar></lomas-public-toolbar>

        <section>
            <mat-card>
                <mat-card-title>Geen toegang</mat-card-title>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <div class="result">
                        <p>Je hebt geen toegang tot deze pagina omdat de login is verlopen</p>
                        <a [routerLink]="['/']">Naar de homepage.</a>
                    </div>

                </mat-card-content>
            </mat-card>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>
